import { noop } from 'underscore';
import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withCustomValidation, withError } from '@bingads-webui-react/validation';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { BusinessNameWithValidation } from '@bingads-webui-campaign-react/business-name';
import { RecommendationContext } from '@bingads-webui-campaign-react/perf-max-recommendation';

const BusinessNameMaxLength = 25;

const BusinessNameWithRecommendation = (props) => {
  const {
    id,
    i18n,
    validationProps,
    updateValidation,
  } = props;

  const { data } = validationProps;
  const [recommendationContext] = useContext(RecommendationContext);
  const currentBusinessName = (data && data.BusinessName) || '';
  const businessNameRecommendationText = recommendationContext && recommendationContext.businessName && recommendationContext.businessName.Text;
  const [prevRecommendation, setPrevRecommendation] = useState();

  // triggered on recommendation change to populate recommendation if field is empty
  useEffect(() => {
    if (prevRecommendation === businessNameRecommendationText) {
      // if we havn't yet prepopulated the business name, or if the recommendation hasn't changed, do nothing
      return;
    }

    // set the prev recommendation so we don't trigger this flow again
    setPrevRecommendation(businessNameRecommendationText);
    if (!currentBusinessName && businessNameRecommendationText) {
      updateValidation([], { BusinessName: businessNameRecommendationText }, false /* shouldDirty */);
    }
  }, [prevRecommendation, businessNameRecommendationText, currentBusinessName, updateValidation]);

  return (
    <BusinessNameWithValidation
      id={id}
      validationProps={{
        data: { BusinessName: currentBusinessName },
      }}
      maxLength={BusinessNameMaxLength}
      i18n={i18n}
      updateValidation={updateValidation}
    />);
};

BusinessNameWithRecommendation.propTypes = {
  id: PropTypes.string,
  storeDetails: PropTypes.shape({
    name: PropTypes.string,
  }),
  i18n: PropTypes.shape({}).isRequired,
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      BusinessName: PropTypes.string,
    }),
  }),
  updateValidation: PropTypes.func,
  recommendationContext: PropTypes.shape({
    businessName: PropTypes.string,
  }).isRequired,
};

BusinessNameWithRecommendation.defaultProps = {
  id: undefined,
  updateValidation: noop,
  storeDetails: undefined,
  validationProps: undefined,
};

export const ValidatedBusinessNameWithRecommendation
  = withControlErrorHandling(withUnvalidatedControlErrors(withError(withCustomValidation(React.memo(BusinessNameWithRecommendation)))));
